export const PARAMS = {
  REFERENCE: 'session',
  REDIRECT: 'redirectUri',
  PRIMARY_COLOR: 'primaryColor',
  IS_DARK_MODE: 'isDarkMode',
  IS_BRANDED: 'isBranded',
} as const

export const EmbeddedAgreementPayloadStatuses = {
  SIGNED: 'SIGNED',
} as const

export const EmbeddedAgreementStatuses = {
  ...EmbeddedAgreementPayloadStatuses,
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
} as const

export const SessionStatusMapping = {
  EXPIRED: 'expired',
  SIGNED: 'signed',
}

export const SessionStatusCodes = {
  ...SessionStatusMapping,
  NO_REFERENCE: 'noReference',
  QUERY_ERROR: 'queryError',
  NO_AGREEMENTS: 'noAgreements',
} as const
